import { render, staticRenderFns } from "./NewsTechnology.vue?vue&type=template&id=529f9575&scoped=true&"
import script from "./NewsTechnology.vue?vue&type=script&lang=js&"
export * from "./NewsTechnology.vue?vue&type=script&lang=js&"
import style0 from "./NewsTechnology.vue?vue&type=style&index=0&id=529f9575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f9575",
  null
  
)

export default component.exports